import { useState, useEffect, useCallback } from 'react';
import API from '../common/api.js';

const useActiveLeadScheduledCall = ({ leadId }) => {
    const [activeLeadScheduledCall, setActiveLeadScheduledCall] = useState(null);
    const [loading, setLoading] = useState(true);
    const [initialized, setInitialized] = useState(false);

    const loadData = useCallback(async () => {
        setLoading(true);

        const activeLeadScheduledCallIfExists = await API.getActiveLeadScheduledCall(leadId);

        setActiveLeadScheduledCall(activeLeadScheduledCallIfExists);

        setInitialized(true);
        setLoading(false);
    }, [leadId]);

    useEffect(() => {
        loadData();
    }, [loadData]);

    return {
        activeLeadScheduledCall,
        loading,
        initialized,
        reload: loadData,
    };
};

export default useActiveLeadScheduledCall;
